import { render } from "./modal-members.vue?vue&type=template&id=22a90562&scoped=true"
import script from "./modal-members.vue?vue&type=script&lang=js"
export * from "./modal-members.vue?vue&type=script&lang=js"

import "./modal-members.vue?vue&type=style&index=0&id=22a90562&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a90562"]])

export default __exports__